export const testIds = {
  menuItem: 'menu-item',
  childrenWrapper: 'children-wrapper',
  itemLabel: 'item-label',
};
